"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBiLogger = void 0;
var tslib_1 = require("tslib");
var web_bi_logger_1 = require("@wix/web-bi-logger");
var opener_utils_1 = require("../utils/opener.utils");
function createBiLogger(defaults) {
    if (defaults === void 0) { defaults = {}; }
    var logger = web_bi_logger_1.default
        .factory({ endpoint: 'feedback-service' })
        .updateDefaults(defaults)
        .logger();
    return {
        log: function (params) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            if (params && params.metasiteId) {
                params = tslib_1.__assign(tslib_1.__assign({}, params), { metasiteId: opener_utils_1.parseMetasiteId(params.metasiteId) });
            }
            return logger.log.apply(logger, tslib_1.__spreadArrays([params], optionalParams));
        },
    };
}
exports.createBiLogger = createBiLogger;
//# sourceMappingURL=create-logger.js.map